import React, { Fragment } from 'react'
import { useLayout, LayoutProps } from './useLayout'
import Header from './Header/Header'
import Footer from './Footer/Footer'
import FloatingActionMenu from 'components/FloatingActionMenu/FloatingActionMenu'
import CartFloatingIcon from 'components/Cart/CartFloatingIcon/CartFloatingIcon'

const Layout: React.FC<LayoutProps> = (props: LayoutProps) => {
  const {
    children,
    plan,
    areOpeningHoursPublished,
    areFeedbacksPublished,
    isChatWithAIPublished,
    isDeliveryOrdersPublished,
    isVisible,
  } = useLayout(props)

  return (
    <Fragment>
      <Header isVisible={isVisible} />
      {children}
      {plan &&
        plan !== 'free' &&
        (areFeedbacksPublished ||
          areOpeningHoursPublished ||
          isChatWithAIPublished) && (
          <FloatingActionMenu
            plan={plan}
            areOpeningHoursPublished={!!areOpeningHoursPublished}
            areFeedbacksPublished={!!areFeedbacksPublished}
            isChatWithAIPublished={!!isChatWithAIPublished}
          />
        )}
      {isDeliveryOrdersPublished && <CartFloatingIcon />}
      <Footer isVisible={isVisible} />
    </Fragment>
  )
}

export default Layout
